import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LOCALSTORAGE_USER } from "../../constants/localStorageConstants";
import { LOGIN_URL } from "../../constants/routeConstants";

const ProtectedRoute = ({
  linkToNavigate = LOGIN_URL,
  roles,
  requiresAuth = true,
}) => {
  const user = JSON.parse(localStorage.getItem(LOCALSTORAGE_USER));

  if (user && requiresAuth && roles.some((x) => user.roles.includes(x))) {
    return <Outlet />;
  } else if (!user && !requiresAuth) {
    return <Outlet />;
  } else {
    return <Navigate to={linkToNavigate} />;
  }

  // return user && roles.some((x) => user.roles.includes(x)) ? (
  //   <Outlet />
  // ) : (
  //   <Navigate to={linkToNavigate} />
  // );
};

export default ProtectedRoute;
